import React from 'react';
import { IonContent, IonPage, withIonLifeCycle } from '@ionic/react';
import { Link } from 'react-router-dom';

//	L O C A L E

import { locale___SbDigitalMenuViewPage } from './sb-digitalmenu-view.locale';

//	S T Y L E

import './sb-digitalmenu-view.style.scss';

//	S T A T E   -   P R O P S

import { props___SbDigitalMenuViewPage, state___SbDigitalMenuViewPage, state___SbDigitalMenuViewPage___default } from './sb-digitalmenu-view.state';

//	T Y P E S

import { type___api___response } from '../../types/type.api';
import { type___digitalmenu___theme } from '../../types/types.theme';

//	L I B S

import { lib_names } from '../../libs/lib.names';

//	S E R V I C E S

import { service_LocalizationService } from '../../services/service-localization';
import { service_RestApiService } from '../../services/service-api';

//	C O M P O N E N T S

import ComCopyrightComponent from '../../components/com-copyright/com-copyright';
import ComDigitalMenuDishComponent from '../../components/com-digitalmenu-dish/com-digitalmenu-dish';
import ComSpinnerInlineComponent from '../../components/com-spinner-inline/com-spinner-inline';

//	M O D A L S

import MdDishViewModal from '../../modals/md-dish-view/md-dish-view';

//	C L A S S

class SbDigitalMenuViewPage extends React.Component<props___SbDigitalMenuViewPage, state___SbDigitalMenuViewPage> {

//#region 																							D E C L A R A T I O N S

	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();
	private readonly _API: service_RestApiService = new service_RestApiService();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___SbDigitalMenuViewPage,
	) {
		super(props);
		this.state = state___SbDigitalMenuViewPage___default;
	}

//#endregion

//#region 																							R E A D   P R O P S

	private read_props___digitalmenu = async () : Promise<void> => {

		const ___temp___event_props___target: 'vanity' | 'id' = (() : 'vanity' | 'id' => { switch (lib_names.regex.types___objectId.test(this.state.digitalmenu___id)) {
			case true: return 'id'; break;
			default: return 'vanity'; break;
		}})() ?? 'vanity';

//	todo redirect to vanity con link/mid/id

		const ___temp___event_props: type___api___response = await this._API.public___read_menu(___temp___event_props___target, this.state.digitalmenu___id!);	
		this.setState({
			digitalmenu___props: (___temp___event_props.response === 'success' && ___temp___event_props.data !== null) ? ___temp___event_props.data : null,
			digitalmenu___props___isLoading: false,
		}, () : void => {
			if (this.state.digitalmenu___props && this.state.digitalmenu___props !== null && this.state.digitalmenu___props['digitalmenu_theme'] && this.state.digitalmenu___props['digitalmenu_theme'] !== null) {
				this.handle___set_theme(this.state.digitalmenu___props['digitalmenu_theme'] as type___digitalmenu___theme); 
			}
		});
	}

//#endregion

//#region 																							H A N D L E R S

	private handle___set_theme = (
		___theme: type___digitalmenu___theme
	) : void => {

		document.documentElement.style.setProperty('--theme---color---background', ___theme.color___background);
		document.documentElement.style.setProperty('--theme---color---foreground', ___theme.color___foreground);
		document.documentElement.style.setProperty('--theme---color---accent', ___theme.color___accent);

		document.documentElement.style.setProperty('--theme---appearance---shadow', ___theme.appearance___shadow);
		document.documentElement.style.setProperty('--theme---appearance---font-family', ___theme.appearance___font_family);
		document.documentElement.style.setProperty('--theme---appearance---border-radius', (___theme.appearance___border_radius.toString() + 'pt'));

	}

	private handle___scroll_to_category = (
		___dish_category_slug: string
	) : void => {
		const ___element_to_scroll_to: HTMLElement | null = document.getElementById(___dish_category_slug);
		if (___element_to_scroll_to) { ___element_to_scroll_to.scrollIntoView({ behavior: 'smooth' }); }
	}

	private handle___scroll_to_top = () : void => {
		const ___element_to_scroll_to: HTMLElement | null = document.getElementById('scroll-to-top---placeholder');
		if (___element_to_scroll_to) { ___element_to_scroll_to.scrollIntoView({ behavior: 'smooth' }); }
	}

	private handle___dish_click = (
		___dish_id: string
	) : void => {
		this.setState({
			md___MdDishViewModal___argument: ___dish_id,
			md___MdDishViewModal___isOpen: true
		});
	}

	private handle___scroll = (
		___e: any
	) : void => {
		const ___temp___scrollTop: number = ___e.target.scrollTop;
		this.setState({
			scrollToTop___isVisible: (___temp___scrollTop > 100) ? true : false,
		});
	}

//#endregion

//#region 																							L I F E C Y C L E

	ionViewDidEnter() : void {
		const ___url: string[] = window.location.toString().replace(/\/$/, '').split('/');
		const ___url___last_param: string = ___url[___url.length - 1];
		const ___url___id: string | null = (___url___last_param) ? ___url___last_param : null;
		this.setState({
			digitalmenu___id: ___url___id!,
			digitalmenu___props___isLoading: true,
		}, async () : Promise<void> => await this.read_props___digitalmenu());
	}

//#endregion

//#region 																							R E T U R N

	render() : React.ReactNode {
		return (
			<IonPage>
				<MdDishViewModal isOpen={ this.state.md___MdDishViewModal___isOpen } dish_id={ this.state.md___MdDishViewModal___argument } event___onDidDismiss={() : void => this.setState({ md___MdDishViewModal___argument: null, md___MdDishViewModal___isOpen: false })}/>
				<IonContent forceOverscroll={false} scrollEvents={true} onIonScroll={this.handle___scroll}>
					<div className="sb-digitalmenu-view---container">
						{(this.state.digitalmenu___props___isLoading === true) ? (
							<div className="sb-digitalmenu-view---container---loading">

								<section></section>

								<section>
									<ComSpinnerInlineComponent />
									<h2>{ this._LOCALE.translate(locale___SbDigitalMenuViewPage.loading___text) }</h2>
								</section>

								<ComCopyrightComponent />

							</div>
						) : (<>

							<div id="scroll-to-top---placeholder"></div>
						
							{(this.state.digitalmenu___props['digitalmenu_logo'] && this.state.digitalmenu___props['digitalmenu_logo'].length > 0) && (<>
								<br />
								<br />
								<div className="sb-digitalmenu-view---logo">
									<img src={this.state.digitalmenu___props['digitalmenu_logo']} />
								</div>
								<br />
								<br />
							</>)}

							<div className="sb-digitalmenu-view---index">
								{this.state.digitalmenu___props['digitalmenu_contents'].map((___d_c: any, ___d_c___idx: number) : React.ReactNode => (___d_c['dish_category_contents'].length > 0) && (
									<div key={ ___d_c___idx } onClick={() : void => this.handle___scroll_to_category(___d_c['dish_category_slug'])}>{ ___d_c['dish_category_name'] }</div>
								))}
							</div>

							<br />

							{this.state.digitalmenu___props['digitalmenu_contents'].map((___d_c: any, ___d_c___idx: number) : React.ReactNode => (
								(___d_c['dish_category_contents'].length > 0) && (<>
									<div key={ ___d_c___idx } className="sb-digitalmenu-view---card" id={___d_c['dish_category_slug']}>
									
										<div className="sb-digitalmenu-view---card---title">
										{/*	<img src={ '/assets/digitalmenu/categories/' + ___d_c['dish_category_icon'] + '.svg' } /> */}
											<h2>{ ___d_c['dish_category_name'] }</h2>
										</div>
									
										<br />

										<div className="sb-digitalmenu-view---card---content">
											{___d_c['dish_category_contents'].map((___dish: any, ___dish___idx: number) : React.ReactNode => (
												<ComDigitalMenuDishComponent key={ ___dish___idx } dish_props={ ___dish } dish_icon={ ___d_c['dish_category_icon'] } event___onClick={(___dish_id: string) : void => this.handle___dish_click(___dish_id)}/>
											))}
										</div>
									
									</div>
									<br />
								</>)
							))}

							{(this.state.scrollToTop___isVisible === true) && (
								<div className="sb-digitalmenu-view---go-up" onClick={() : void => this.handle___scroll_to_top()}>
									<i className="fas fa-chevron-up"></i>
								</div>
							)}

							<br />
							<br />
							<br />

							<Link to="/info/allergens" className="sb-digitalmenu-view---go-to-allergens">
								<span>{ this._LOCALE.translate(locale___SbDigitalMenuViewPage.button___allergen_list) }</span>
								<i className="fas fa-chevron-right"></i>
							</Link>

							<br />
							<br />
							<br />

							<ComCopyrightComponent />

							<br />
							<br />
							<br />
							<br />
							<br />
							<br />

						</>)}
					</div>
				</IonContent>
			</IonPage>
		);
	}

//#endregion

}

//	E X P O R T

export default withIonLifeCycle(SbDigitalMenuViewPage);